var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "resultWord-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            loading: _vm.loading.form,
            "btn-loading": _vm.loading.btn,
            submit: false,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 70,
                            label: "助记词",
                            prop: "errorConfigId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "助记词",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.edit.errorConfigId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.edit,
                                    "errorConfigId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "edit.errorConfigId",
                              },
                            },
                            _vm._l(_vm.mnemonicPhrases, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: item.evaluation,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 70,
                            label: "编码",
                            prop: "code",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: { type: "text", placeholder: "请输入编码" },
                            model: {
                              value: _vm.edit.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "code", $$v)
                              },
                              expression: "edit.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 70,
                            label: "原因",
                            prop: "reason",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入原因",
                              rows: 3,
                              maxlength: "200",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.edit.reason,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "reason", $$v)
                              },
                              expression: "edit.reason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 70,
                            label: "建议",
                            prop: "propose",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入建议",
                              maxlength: "500",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.edit.propose,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "propose", $$v)
                              },
                              expression: "edit.propose",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }